module.exports = __webpack_public_path__ + "img/NHS.076cfed3.jpg";